import {epos2Axios, goAxios} from "@/interceptors/axios";

class GarmentTypeService {
    getAll() {
        return epos2Axios.get('/api/garmenttypes');
    }

    getServiceTypes() {
        return epos2Axios.get('/api/servicetypes');
    }

    getSuppliersList() {
        return epos2Axios.get('/api/supplierslist');
    }

    getGarmentsMainTypes() {
        return epos2Axios.get('/api/garmentsmaintypes');
    }

    getGarmentType(id) {
        return epos2Axios.get('/api/garmenttypes/' + id);
    }

    updateGarmentType(id, garmentTypeData) {
        return epos2Axios.put(
            `/api/garmenttypes/${id}`,
            garmentTypeData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }

    patchGarmentType(id, garmentTypeData) {

        return epos2Axios.patch(
            `/api/garmenttypes/${id}`,
            garmentTypeData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }

    createGarmentType(garmentTypeData) {
        return epos2Axios.post(
            `/api/garmenttypes`,
            garmentTypeData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }

    newServicePrice(servicePriceData) {
        return epos2Axios.post(
            `/api/serviceprices`,
            servicePriceData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }

    updateServicePrice(id, servicePriceData) {
        return epos2Axios.put(
            `/api/serviceprices/` + id,
            servicePriceData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }

    getServicePrices(garmenttypeId) {
        return epos2Axios.get('/api/serviceprices?garmenttype_id=' + garmenttypeId);
    }

    getFilteredServicePrices(garmentTypeId) {
        return goAxios.get('/api/serviceprices?garment_type_id=' + garmentTypeId);
    }

    getServicePrice(servicePriceId) {
        return epos2Axios.get('/api/serviceprices/' + servicePriceId);
    }

    deleteServicePrice(serviceId) {
        return epos2Axios.delete('/api/serviceprices/' + serviceId);
    }

    getGarmentCustomers(garmenttypeId) {
        return epos2Axios.get('/api/garmenttypes/' + garmenttypeId + '/customers');
    }

    searchCustomers(queryString) {
        if (queryString == undefined) {
            queryString = "";
        }
        return epos2Axios.get('/api/customers/search?query=' + queryString);
    }

    addCustomerGarmentType(id, formData) {
        return epos2Axios.post(
            `/api/garmenttypes/${id}/customers`,
            formData,
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }
        );
    }
}

export default new GarmentTypeService();